export const uiColumnToExportColumnMap = {
  amountPaid: 'AmountPaid',
  assignedTo: 'AssignedTo',
  createdDate: 'CreatedDate',
  marketplaceNotified: 'IsMarketplaceNotified',
  orderNumber: 'OrderNumber',
  provider: 'Provider',
  service: 'Service',
  shipDate: 'ShipDate',
  city: 'ShipToCity',
  country: 'ShipToCountry',
  recipient: 'shipToName',
  state: 'ShipToState',
  tracking: 'TrackingNumber',
  status: 'Status',
  quantity: 'Quantity',
  shipmentNotification: 'ShipmentNotification',
  batchName: 'BatchNumber',
  carrier: 'Carrier',
  company: 'ShipToCompany',
  delegationDate: 'DelegationDate',
  deliveryNotification: 'IsDeliveryEmailSent',
  orderDate: 'OrderDate',
  labelCreated: 'IsLabelCreated',
  packingSlipPrinted: 'IsPackingSlipPrinted',
  paidDate: 'paidDate',
  postalCode: 'ShipToPostalCode',
  shipmentNumber: 'FulfillmentPlanId',
  shippingPaid: 'ShippingPaid',
  source: 'Source',
  store: 'Store',
  taxPaid: 'TaxPaid',
  weight: 'Weight',
};
